import { render, staticRenderFns } from "./guest-price-warning.vue?vue&type=template&id=3e4ad2d7"
import script from "./guest-price-warning.vue?vue&type=script&lang=js"
export * from "./guest-price-warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./guest-price-warning.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports